import script from "./ProfileInfoItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileInfoItem.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__